<template>
  <div class="music-player-marquee">
    <p v-if="text">
      <span
        v-for="index in 2"
        :key="index"
        :style="{ minWidth: `${offsetWidth}px` }"
        v-text="text"
      />
    </p>
  </div>
</template>

<script>
export default {
  name: 'MusicPlayerMarquee',
  props: {
    text: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      offsetWidth: 0
    }
  },
  updated () {
    this.offsetWidth = this.$el.offsetWidth
  }
}
</script>

<style lang="stylus" scoped>
@keyframes marquee {
  0% {
    transform: translateX(0%);
  }
  100% {
    transform: translateX(-50%);
  }
}

.music-player-marquee {
  width: 100%;
  min-height: 1em;
  margin: 0;
  padding: 0;
  overflow: hidden;

  p, span {
    display: inline-block;
  }

  p {
    margin: 0;
    padding: 0;
    white-space: nowrap;
    animation-name: marquee;
    animation-duration: 5s;
    animation-iteration-count: infinite;
    animation-timing-function: linear;
  }

  span {
    padding-right: 3em;
  }
}
</style>
